var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.638 7.207H8.26a.656.656 0 0 1 .077 1.307l-.077.004H5.638a1.967 1.967 0 0 0-.116 3.932l.116.003H8.26a.656.656 0 0 1 .077 1.307l-.077.005H5.638a3.28 3.28 0 0 1-.142-6.555l.142-.003Zm9.181 0a3.279 3.279 0 1 1 0 6.558h-2.623a.656.656 0 0 1 0-1.312h2.623a1.967 1.967 0 1 0 0-3.935h-2.623a.656.656 0 0 1 0-1.311h2.623ZM12.196 9.83a.656.656 0 0 1 0 1.312H8.26a.656.656 0 1 1 0-1.312h3.935Z",
    fill: "#fff"
  })));
};
export default SvgLink;